import backendHttpClient, { headerToken } from "./httpClient";

export const pointsProductList = async (params) => {
  return await backendHttpClient.get(`/products`, params, headerToken());
};
export const usernameList = async (params) => {
  return await backendHttpClient.get(`/userInfo`, params, headerToken());
};
